const MainStyles = {
  
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    black_2: '#151515',
    blue: '#00b1ed',
    blue_2: '#00b0f0',
    blue_dark: '#001e50',
    gray: '#6a767d',
    gray_2: '#7f8991',
    gray_3: '#6a767d',
    gray_4: '#c2cacf'
  },

  containerGradient: {
    background: 'rgb(0,66,121)',
    background: 'linear-gradient(90deg, rgba(0,66,121,1) 60%, rgba(0,30,80,1) 100%)'
  }
}

export default MainStyles